// extracted by mini-css-extract-plugin
module.exports = {"streamingSettingsHolder":"SettingsPopup_streamingSettingsHolder__JTJNK","liveWarningHolder":"SettingsPopup_liveWarningHolder__1LFA1"};